import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-6" }
const _hoisted_2 = ["src", "alt"]

import type { MemberProps } from "./MemberProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'Member',
  props: {
    name: {},
    role: {},
    imageSrc: {},
    nameTextColor: {},
    roleTextColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "size-16 rounded-full",
        src: _ctx.imageSrc,
        alt: _ctx.name,
        loading: "lazy"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", null, [
        _createElementVNode("h3", {
          class: "text-base/7 font-semibold tracking-tight",
          style: _normalizeStyle({ color: _ctx.nameTextColor })
        }, _toDisplayString(_ctx.name), 5),
        _createElementVNode("p", {
          class: "text-sm/6 font-semibold",
          style: _normalizeStyle({ color: _ctx.roleTextColor })
        }, _toDisplayString(_ctx.role), 5)
      ])
    ])
  ]))
}
}

})